/**
 * Created by Oles on 5/5/2017.
 */
import {connect} from 'react-redux';
import * as actions from '../actions/index';
import GenesTable from "../components/GenesTable.jsx";
import {GenesClassifications} from "../const/TestResultsConst";
import {I18n} from 'react-redux-i18n';

const mapStateToProps = (state, ownProps) => {
    let genes = state.testDetails.test.genes;
    let allGenes = state.genes ? state.genes.slice() : [];
    let classArray = [];
    GenesClassifications.forEach(function(e, i) {
        classArray.push(I18n.t(e));
    });

    allGenes.unshift('');
    classArray.unshift('');

    genes.forEach((gene) => {
        if (allGenes.indexOf(gene.gene) == -1) {
          allGenes.push(gene.gene);
        }
        if (classArray.indexOf(gene.classification) == -1) {
            classArray.push(gene.classification);
        }
        if (classArray.indexOf(gene.priorClassification) == -1) {
            classArray.push(gene.priorClassification);
        }
    });

    return {
        genes: genes,
        allGenes: allGenes,
        classifications: classArray,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        checkGene: (id,checked) => dispatch(actions.checkGene(id,checked)),
        updateGenesTableRow: (geneId,fieldId,value) => dispatch(actions.updateGenesTableRow(geneId, fieldId, value)),
        checkAllGenes: checked => dispatch(actions.selectAllGenes(checked)),
        onAddRow: () => dispatch(actions.addGenesTableRow()),
        onDeleteRow: () => dispatch(actions.deleteGenesTableRow()),
    };
};

const GenesTableController = connect(
    mapStateToProps,
    mapDispatchToProps
)(GenesTable);

export default GenesTableController;